/*
 * Os poucos ícones da casca desenhados com o Lucide (traço de
 * 2px, pontas redondas) e que o Font Awesome do Flarum não tem com o mesmo
 * traço: o hambúrguer, a lupa da busca e o atalho da busca avançada. O CSS
 * (.CanelaIcon, em Header.less) dá cor e tamanho.
 */

// Os desenhos vêm da camada de ícones do tema (icons/glyphs.ts), numa fonte
// só.
import { lucideChildren } from '../icons';
function svg(className, children) {
  return m("svg", {
    className: `CanelaIcon ${className}`,
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    focusable: "false"
  }, children);
}

/** lucide "menu" */
export function menuIcon() {
  return svg('CanelaIcon--menu', lucideChildren('menu'));
}

/** lucide "search" */
export function searchIcon() {
  return svg('CanelaIcon--search', lucideChildren('search'));
}

/** lucide "sliders-horizontal" */
export function slidersIcon() {
  return svg('CanelaIcon--sliders', lucideChildren('sliders-horizontal'));
}
flarum.reg.add('ramon-canela', 'forum/utils/shellIcons', { menuIcon: menuIcon,searchIcon: searchIcon,slidersIcon: slidersIcon, });